module.exports = __webpack_public_path__ + "img/jicheng (3).7740a3d4.png";